import config from "../../config/config.json";
import { getHeaders } from "../../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
  cancelPreviousRequest,
  decryptResponse
} from "../../APIHelpers/Responses";

export const accountServices = {
  addNewAccount,
  updatedAccount,
  deleteAccount,
  getAccountList,
};

// Add New Account
async function addNewAccount(auth, userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewAccount`,
    headersWithAuth("POST", userData, getHeaders(auth))
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Update Account
async function updatedAccount(auth, userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updatedAccount`,
    headersWithAuth("PUT", userData, getHeaders(auth))
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Delete Account
async function deleteAccount(auth, userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteAccount`,
    headersWithAuth("DELETE", userData, getHeaders(auth))
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Get All Account
async function getAccountList(auth, adminId, type) {
  try {
    const signal = cancelPreviousRequest(`getAccountList`);
    let apiURL = `${config.API_URL_USER_ONBOARDING}getAccountList/${adminId}/${type}`
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", getHeaders(auth)),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if(data?.statusCode === 401){
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}